<div class="access-required-wrapper">
  <div class="access-required-card">
    <div class="icon-circle">
      <span class="material-icons">lock</span>
    </div>
    <h1 class="title">Access Restricted</h1>
    <p class="subtitle">You don't have permission to access this feature.</p>
    <div class="divider"></div>
    <p class="message">
      Please contact your <span class="highlight">Administrator</span> to request access or upgrade your plan.
    </p>
    <button class="btn-back" (click)="goBack()">
      <span class="material-icons">arrow_back</span>
      Home
    </button>
  </div>
</div>
